module.exports = __webpack_public_path__ + "img/Patch14-1.41f886be.webp";